import { useMemo } from "react";
import { filterClinics } from "../utils/filterClinics";
import { sortClinics } from "../utils/sortClinics";

/**
 * Builds the rows the clinic table shows: pending import rows first, then
 * saved clinics, each numbered by that position (`rowNumber`) before the search,
 * filters and sort are applied, so a clinic keeps its number in any view.
 */
export default function useVisibleClinics({
  pendingRows,
  savedClinics,
  tiers,
  search,
  filters,
  sort,
}) {
  const tiersById = useMemo(
    () => new Map((tiers ?? []).map((tier) => [tier.id, tier])),
    [tiers],
  );

  const numberedRows = useMemo(
    () =>
      [...pendingRows.map((row) => ({ ...row, isPending: true })), ...savedClinics].map(
        (clinic, index) => ({ ...clinic, rowNumber: index + 1 }),
      ),
    [pendingRows, savedClinics],
  );

  return useMemo(
    () => sortClinics(filterClinics(numberedRows, search, filters), sort, tiersById),
    [numberedRows, search, filters, sort.orderBy, sort.order, tiersById],
  );
}
